import { ROUTES } from '@dashboard/router/routeNames'

export default [
  {
    path: 'widgets',
    children: [
      {
        name: ROUTES.WIDGETS,
        path: '',
        component: () => import('./pages/WidgetsIndex.vue'),
        meta: {
          title: 'Widgets',
          description: `Widgets are how your Flows are displayed across your website. They determine the look and feel of the questions and offers that you include in the Flow they're attached to.`,
          rightyPrompts: [
            {
              label: 'Create a widget',
              drawerLabel: 'Help me create a new widget',
              prompt:
                'Help me create a new widget. I want to display a flow on my website with a specific trigger and appearance.'
            },
            {
              label: 'Widget best practices',
              drawerLabel: 'What are widget best practices?',
              prompt:
                'What are the best practices for widget triggers and placement? When should I use exit intent vs scroll vs time-based triggers?'
            },
            {
              label: 'Compare widgets',
              drawerLabel: 'Compare my widget performance',
              prompt:
                'Compare my widgets by engagement and conversion rate. Which widgets are performing best and which need improvement?'
            }
          ]
        }
      },
      {
        name: ROUTES.CREATEWIDGET,
        path: 'new',
        component: () => import('./pages/WidgetCreate.vue')
      },
      {
        name: ROUTES.WIDGET,
        path: ':widgetId',
        component: () => import('./pages/WidgetShowV2.vue'),
        props: true,
        meta: {
          rightyPrompts: [
            {
              label: 'Match my site',
              drawerLabel: 'Match this widget to my site design',
              prompt:
                'Analyze my website and recommend colors, fonts, and styling for widget {{widgetId}} so it matches my brand. Extract the key colors and suggest specific values for the widget palette.'
            },
            {
              label: 'Custom CSS help',
              drawerLabel: 'Help me write custom CSS',
              prompt:
                'I need help writing custom CSS for widget {{widgetId}}. What CSS selectors are available, and can you help me style specific elements?'
            },
            {
              label: 'Optimize trigger',
              drawerLabel: "Optimize this widget's trigger timing",
              prompt:
                "Analyze this widget's trigger settings and suggest optimal timing for maximum engagement without annoying visitors. What trigger timing works best for this type of widget?"
            },
            {
              label: 'Placement ideas',
              drawerLabel: 'Where else should I show this widget?',
              prompt:
                "Based on this widget's purpose and flow, where else on my site should I consider showing it? What pages would benefit from this widget?"
            }
          ]
        }
      }
    ]
  }
]
